import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

// Event startsAt/endsAt are wall clock times in the event's timezone. The
// result is only meant for comparisons and relative time against the current
// clock; calling .format() on it would show the viewer's local clock instead.
export const eventInstant = (wallClock: string, timeZone?: string): Dayjs => {
  if (!timeZone) return dayjs(wallClock)

  try {
    return dayjs.tz(wallClock, timeZone)
  } catch {
    return dayjs(wallClock)
  }
}
